// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"4d55213f","498":"e66116c1","598":"c357dd50","703":"505c6310"}[chunkId] + ".chunk.js";
};